<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router/dist/vue-router'
import { useRouter } from 'vue-router'

import { RHDHVHeader } from '@haskoning/vue-component-library'
import { useEventsBus } from '@haskoning/vue-component-library'

import SidebarToggleButton from '@/components/app/SidebarToggleButton.vue'
import BreadCrumb from '@/components/app/BreadCrumb.vue'

import { useAuthorizationStore } from '@/stores/authorization'
import { useDjangoAuthStore } from '@/stores/authDjango'

const route = useRoute()
const router = useRouter()
const authorizationStore = useAuthorizationStore()
const authStore = useDjangoAuthStore()

const { items: authorizations } = storeToRefs(authorizationStore)
const { user } = storeToRefs(authStore)
const { bus } = useEventsBus()

const loading = ref(false)

const currentRouteName = computed(() => route.name)

const isToggleButtonShown = computed(() => {
  const routeName = currentRouteName.value
  return (
    typeof routeName === 'string' &&
    ['calculation-index', 'user-management', 'calculation'].includes(routeName)
  )
})

watch(
  () => bus.value.get('loading'),
  (val) => {
    loading.value = val[0]
  }
)

const goToProjectIndex = () => {
  router.push({ name: 'project-index' })
}

const logout = async () => {
  await authStore.logout()
  await router.push({ name: 'auth-login' })
}

onMounted(async () => {
  if (authorizations.value.length === 0) {
    await authorizationStore.fetchItems()
  }
  authorizationStore.setCurrentRole([user.value.role])
})
</script>

<template>
  <RHDHVHeader
    title="MOOR²"
    :user="user"
    image-src="/logo-rhdhv-white.png"
    :loading="loading"
    menuColor="white"
    @logo-click="goToProjectIndex"
    @logout="logout"
  >
    <template v-if="isToggleButtonShown" v-slot:toolbar-prepend>
      <SidebarToggleButton />
    </template>
    <template v-slot:breadcrumbs-items>
      <BreadCrumb />
    </template>
  </RHDHVHeader>
</template>

<style scoped>
.no-overlay :deep(.v-btn__overlay) {
  display: none;
}
</style>
